export const marginTop = (gap: number | number[]) =>
  (Array.isArray(gap) && gap[0]) || Number(gap) || 0;

export const marginLeft = (gap: number | number[]) =>
  (Array.isArray(gap) && gap[1]) || Number(gap) || 0;
export const rem = (number: number) =>
  Number.isFinite(number) && `${number}` !== '0' ? `${number}rem` : undefined;
